import { MiddlewareAction } from "../middleware";
import {
  PolicyAttachmentFilters,
  CreatePolicyAttachmentRequest,
  UpdatePolicyAttachmentStatusRequest,
} from "../models/underwritingPolicyAttachment";

export enum PolicyAttachmentActions {
  REQUEST_GET_ACTIVE_SEGMENTS = "REQUEST_GET_ACTIVE_SEGMENTS",
  REQUEST_GET_POLICY_ATTACHMENTS = "REQUEST_GET_POLICY_ATTACHMENTS",
  REQUEST_GET_POLICY_ATTACHMENT_FILTER_OPTIONS = "REQUEST_GET_POLICY_ATTACHMENT_FILTER_OPTIONS",
  REQUEST_GET_POLICY_ATTACHMENT_CREATION_OPTIONS = "REQUEST_GET_POLICY_ATTACHMENT_CREATION_OPTIONS",
  REQUEST_CREATE_POLICY_ATTACHMENT_SHADOW = "REQUEST_CREATE_POLICY_ATTACHMENT_SHADOW",
  REQUEST_UPDATE_POLICY_ATTACHMENT_STATUS = "REQUEST_UPDATE_POLICY_ATTACHMENT_STATUS",
  REQUEST_GET_POLICY_ATTACHMENT_TIMELINE = "REQUEST_GET_POLICY_ATTACHMENT_TIMELINE",
}

export function getActiveSegments(): MiddlewareAction {
  return {
    actionName: PolicyAttachmentActions.REQUEST_GET_ACTIVE_SEGMENTS,
    type: "GET",
    url: "/v1/segments",
    throwOnError: true,
  };
}

export function getPolicyAttachments(
  filters?: PolicyAttachmentFilters
): MiddlewareAction {
  return {
    actionName: PolicyAttachmentActions.REQUEST_GET_POLICY_ATTACHMENTS,
    type: "GET",
    url: "/v1/underwriting/policy-attachments",
    queryParams: filters as Record<string, any>,
    throwOnError: true,
  };
}

export function getPolicyAttachmentFilterOptions(): MiddlewareAction {
  return {
    actionName: PolicyAttachmentActions.REQUEST_GET_POLICY_ATTACHMENT_FILTER_OPTIONS,
    type: "GET",
    url: "/v1/underwriting/policy-attachments/filter-options",
    throwOnError: true,
  };
}

export function getPolicyAttachmentCreationOptions(): MiddlewareAction {
  return {
    actionName: PolicyAttachmentActions.REQUEST_GET_POLICY_ATTACHMENT_CREATION_OPTIONS,
    type: "GET",
    url: "/v1/underwriting/policy-attachments/creation-options",
    throwOnError: true,
  };
}

export function createPolicyAttachmentInShadow(
  payload: CreatePolicyAttachmentRequest
): MiddlewareAction {
  return {
    actionName: PolicyAttachmentActions.REQUEST_CREATE_POLICY_ATTACHMENT_SHADOW,
    type: "POST",
    url: "/v1/underwriting/policy-attachments/shadow",
    body: payload,
  };
}

export function updatePolicyAttachmentStatus(
  id: string,
  payload: UpdatePolicyAttachmentStatusRequest
): MiddlewareAction {
  return {
    actionName: PolicyAttachmentActions.REQUEST_UPDATE_POLICY_ATTACHMENT_STATUS,
    type: "PATCH",
    url: `/v1/underwriting/policy-attachments/${id}/status`,
    body: payload,
  };
}

export function getPolicyAttachmentTimeline(
  employerId: string
): MiddlewareAction {
  return {
    actionName: PolicyAttachmentActions.REQUEST_GET_POLICY_ATTACHMENT_TIMELINE,
    type: "GET",
    url: "/v1/underwriting/policy-attachments/timeline",
    queryParams: { employerId },
  };
}
